<template>
<v-card v-resize="onResize" class="ma-2 pa-2" height = "100%"> 
  <v-card-text>
    <p class="text-center title pb-0 mb-0 font-weight-regular">Temp (F) and Energy Usage (kWh)</p>
  </v-card-text>
  <div id='mainGraph' style='height:800px;'></div>
</v-card>
</template>
<script>
import shine from '@/components/plugins/echarts-theme-shine';

export default{
  data: () => ({
    date: [],
    mainGraph: null,
    startDate: null,
    endDate: null,
    temp: null,
   
   // General graph template
    option: {
      color: [
        '#f09706','#bfcd38',"#ce561a","#639719",
        '#6e47b7','#3d86cf',"#9e9f93","#b57dbd",'#bfcd38',"#ce561a",
      ],
      tooltip: {
          trigger: 'axis'
      },
      legend: {
          data: ["Actual Temp", "Pred. Temp", "DryBulb Temp","Dew Pt. Temp",
                  "Actual HVAC", 'Pred. HVAC', "Actual CCHW", "Pred. CCHW",'Enthalpy','Type Behavior']
      },
      grid: [
        {left: '4%', top: '5%',  right: '1%', height: '27%'},
        {left: '4%', top: '35%', right: '1%', height: '27%'},
        {left: '4%', top: '65%', right: '1%', height: '27%'},
      ],
      toolbox: {
          feature: {
              saveAsImage: {}
          }
      }, 
      dataset:{
        source: null,
        dimensions: ["dateTime", "dryB Temp","dewP Temp", "Real Temp", "Pred Temp",
                        "Real HVAC", "Pred HVAC", "Real CCHW", "Pred CCHW",'Enthalpy','Type Behavior']
      },
      // weird isssue with datazoom where datazoom causes lines to not show when using grid
      dataZoom: [
        {
          type: 'inside',
          xAxisIndex: [0, 1, 2],
          minValueSpan: 3600 * 24 * 1000 * 40, //end integer is how many days the interval can be
          //filterMode: 'filter'
          start: 0,
          end: 100,
        },{
          show: false,
          type: 'slider',
          xAxisIndex: [0, 1, 2],
          minValueSpan: 3600 * 24 * 1000 * 40, //end integer is how many days the interval can be
          top: '95.5%',
          start: 0,
          end: 100,
        }
      ],

      xAxis: [
      {type: 'time', gridIndex: 0, splitArea: {show: true}, axisLabel: {show: false}},
      {type: 'time', gridIndex: 1, splitArea: {show: true}, axisLabel: {show: false}},
      {type: 'time', gridIndex: 2, splitArea: {show: true}, 
        name: 'Date/Time', nameLocation: 'middle', nameGap: 45,
        axisLabel: {
          formatter: {
            year: '{yy} {MMM}',
            month: '{MMM}',
            day: '',
            hour: '',
            minute: '{HH}:{mm}',
            second: '{HH}:{mm}:{ss}',
            millisecond: '{hh}:{mm}:{ss} {SSS}',
            none: '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss} {SSS}'
          },
        }},
      ],

      series: [
        {
          name: 'DryBulb Temp',
          type: 'line',
          xAxisIndex: 0,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {opacity: 0.15},
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'dryB Temp' // refer sensor 1 value 
          },
        },{
          name: 'Dew Pt. Temp',
          type: 'line',
          xAxisIndex: 0,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {opacity: 0.4},
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'dewP Temp' // refer sensor 1 value 
          },
        },{
          name: 'Actual Temp',
          type: 'line',
          xAxisIndex: 0,
          yAxisIndex: 0,
          showSymbol: false,
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'Real Temp' // refer sensor 1 value 
          },
        },{
          name: 'Pred. Temp',
          type: 'line',
          xAxisIndex: 0,
          yAxisIndex: 0,
          showSymbol: false,
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'Pred Temp' // refer sensor 1 value 
          },
        },{
          name: 'Actual HVAC',
          type: 'line',
          xAxisIndex: 1,
          yAxisIndex: 1,
          showSymbol: false,
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'Real HVAC' // refer sensor 1 value 
          },
        },{
          name: 'Pred. HVAC',
          type: 'line',
          xAxisIndex: 1,
          yAxisIndex: 1,
          showSymbol: false,
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'Pred HVAC' // refer sensor 1 value 
          },
        },{
          name: 'Actual CCHW',
          type: 'line',
          xAxisIndex: 2,
          yAxisIndex: 2,
          showSymbol: false,
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'Real CCHW' // refer sensor 1 value 
          },
        },{
          name: 'Pred. CCHW',
          type: 'line',
          xAxisIndex: 2,
          yAxisIndex: 2,
          showSymbol: false,
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'Pred CCHW' // refer sensor 1 value 
          },
        },{
          name: 'Enthalpy',
          type: 'line',
          xAxisIndex: 2,
          yAxisIndex: 2,
          showSymbol: false,
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'Enthalpy' // refer sensor 1 value 
          },
        },{
          name: 'Type Behavior',
          type: 'line',
          xAxisIndex: 2,
          yAxisIndex: 2,
          showSymbol: false,
          silent: true,
          encode: {
            x: 'dateTime',
            y: 'Type Behavior' // refer sensor 1 value 
          },
        },
      ],

      yAxis: null,

    },
  }),

  ///////////////////// METHODS ///////////////////
  methods: {
    showGraph: _.debounce(async function() {

      if (this.runState === "running") {
        this.mainGraph.showLoading()
        
      } else if (this.runState === "finished"){
        this.mainGraph.hideLoading()
        this.refreshGraph()
      }
    }),
    onResize() {  // calls echarts .resize function when viewing window changes
      if(this.mainGraph) _.debounce(this.mainGraph.resize, 100)()
    },
    refreshGraph() {
      switch(this.graphType) {
        case "month":
          this.set_MonthGraph()
          break;
        case "week":
          this.set_WeekGraph()
          break;
        case "day":
          this.set_DayGraph()
          break;
        case "hour":
          this.set_HourGraph()
          break;
      }
    },
    set_MonthGraph() {

      let yAxis = [
        {type: 'value', gridIndex: 0, name: "Temperature\n[deg.F]",
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.floor(value.min-5)},
          max: function (value) { return Math.floor(value.max+5)},
        
        },{type: 'value', gridIndex: 1, name: "Elec. Load\n[MWh]", 
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.floor(value.min-1)},
          max: function (value) { return Math.floor(value.max+1)},
        
        },{type: 'value', gridIndex: 2, name: "CCHW Load\n[kton-hrs]",
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.floor(value.min-1)},
          max: function (value) { return Math.floor(value.max+1)},
        }
      ]  
      
      // Overwriting main template with setting specific options
      this.option.dataset.source = this.m_dataArray         // assiging dataset
      this.option.yAxis = yAxis                             // assigning yaxis
      for (let i = 4; i < this.option.series.length; i++) { // assigns line type for hvac and chw graphs
        this.option.series.[i].type = 'bar'
      }

      this.mainGraph.setOption(this.option)
    },
    set_WeekGraph() {
      let yAxis = [
        {type: 'value', gridIndex: 0, name: "Temperature\n[deg.F]",
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.floor(value.min-5)},
          max: function (value) { return Math.floor(value.max+5)},
          },
        {type: 'value', gridIndex: 1, name: "Elec. Load\n[MWh]", 
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.round(value.min*10-2)/10},
          max: function (value) { return Math.round(value.max*10+2)/10},
          },
        {type: 'value', gridIndex: 2, name: "CCHW Load\n[kton-hrs]",
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.round(value.min*10-2)/10},
          max: function (value) { return Math.round(value.max*10+2)/10},
          },
      ]

      // Overwriting main template with setting specific options
      this.option.dataset.source = this.w_dataArray         // assiging dataset
      this.option.yAxis = yAxis                             // assigning yaxis
      for (let i = 4; i < this.option.series.length; i++) { // assigns line type for hvac and chw graphs
        this.option.series.[i].type = 'bar'
      }

      this.mainGraph.setOption(this.option)
    },
    set_DayGraph() {
      let yAxis = [
        {type: 'value', gridIndex: 0, name: "Temperature\n[deg.F]",
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.floor(value.min-5)},
          max: function (value) { return Math.floor(value.max+5)},
          },
        {type: 'value', gridIndex: 1, name: "Elec. Load\n[MWh]", 
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.round(value.min*10-1)/10},
          max: function (value) { return Math.round(value.max*10+1)/10},
          },
        {type: 'value', gridIndex: 2, name: "CCHW Load\n[kton-hrs]",
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.round(value.min*10-1)/10},
          max: function (value) { return Math.round(value.max*10+1)/10},
          },
      ]

      // Overwriting main template with setting specific options
      this.option.dataset.source = this.d_dataArray         // assiging dataset
      this.option.yAxis = yAxis                             // assigning yaxis
      for (let i = 4; i < this.option.series.length; i++) { // assigns line type for hvac and chw graphs
        this.option.series.[i].type = 'bar'
      }

      this.mainGraph.setOption(this.option)
    },
    set_HourGraph() {
      let yAxis = [
        {type: 'value', gridIndex: 0, name: "Temperature\n[deg.F]",
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.floor(value.min-5)},
          max: function (value) { return Math.floor(value.max+5)},
          },
        {type: 'value', gridIndex: 1, name: "Elec. Load\n[kWh]", 
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.floor(value.min-5)},
          max: function (value) { return Math.floor(value.max+5)},
          },
        {type: 'value', gridIndex: 2, name: "CCHW Load\n[kton-hrs]",
          nameLocation: 'middle', nameGap: 29,
          min: function (value) { return Math.floor(value.min-5)},
          max: function (value) { return Math.floor(value.max+5)},
          },
      ]

      // Overwriting main template with setting specific options
      this.option.dataset.source = this.dataArray             // assiging dataset
      this.option.yAxis = yAxis                               // assigning yaxis
      for (let i = 4; i < this.option.series.length; i++) {   // assigns line type for hvac and chw graphs
        this.option.series.[i].type = 'line'
      }

      this.mainGraph.setOption(this.option)
    },
    combine: function(arr1, arr2, arr3, arr4, arr5, arr6, arr7, arr8, arr9, arr10,arr11) {
      return arr1.map(function(v,i) {
          return [v, arr2[i], arr3[i], arr4[i], arr5[i], arr6[i], arr7[i], arr8[i], arr9[i], arr10[i], arr11[i]]
      })
    },
  },
  watch: {
    '$store.state.DTW.run': function() {
      this.showGraph()
    },
    '$store.state.DTW.graphType': function() {
      this.refreshGraph()
    }
  },
  computed: {
    runState(){
      return this.$store.state.DTW.run
    },
    graphType(){
      return this.$store.state.DTW.graphType
    },
    dtwData(){
      return this.$store.state.DTW_data.data
    },
    dataArray(){
      return this.combine(
        this.$store.state.DTW_data.date_time,
        this.$store.state.DTW_data.dryB_Temp,
        this.$store.state.DTW_data.dewP_Temp,                
        this.$store.state.DTW_data.real_Temp,
        this.$store.state.DTW_data.pred_Temp,
        this.$store.state.DTW_data.real_HVAC,
        this.$store.state.DTW_data.pred_HVAC,
        this.$store.state.DTW_data.real_CCHW,
        this.$store.state.DTW_data.pred_CCHW,
        this.$store.state.DTW_data.enthalpy,
        this.$store.state.DTW_data.typeBehavior,
      )
    },
    m_dataArray(){
      this.date =  Object.values(this.dtwData.m_DateTime).filter(
        function(x){ return x !== null}).map( 
          function(x) {return new Date(x).setDate(1)})
      return this.combine(
      this.date,
      Object.values(this.dtwData.m_dryB).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.m_dewP).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.m_Temp_act).filter(function(x){ return x !== null}),      
      Object.values(this.dtwData.m_Temp).filter(function(x){ return x !== null}), 
      Object.values(this.dtwData.m_HVAC_act).filter(function(x){ return x !== null}),    
      Object.values(this.dtwData.m_HVAC).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.m_CCHW_act).filter(function(x){ return x !== null}),     
      Object.values(this.dtwData.m_CCHW).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.m_enthalpy).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.m_typeBehavior).filter(function(x){ return x !== null}),
      )
    },
    w_dataArray(){
      this.date =  Object.values(this.dtwData.w_DateTime).filter(
        function(x){ return x !== null}).map( 
          function(x) {return new Date(x).setHours(0)})
      return this.combine(
        this.date,
      Object.values(this.dtwData.w_dryB).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.w_dewP).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.w_Temp_act).filter(function(x){ return x !== null}),      
      Object.values(this.dtwData.w_Temp).filter(function(x){ return x !== null}), 
      Object.values(this.dtwData.w_HVAC_act).filter(function(x){ return x !== null}),    
      Object.values(this.dtwData.w_HVAC).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.w_CCHW_act).filter(function(x){ return x !== null}),     
      Object.values(this.dtwData.w_CCHW).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.w_enthalpy).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.w_typeBehavior).filter(function(x){ return x !== null}),
      )
    },
    d_dataArray(){
      this.date =  Object.values(this.dtwData.d_DateTime).filter(
        function(x){ return x !== null}).map( 
          function(x) {return new Date(x).setHours(0)})
      return this.combine(
        this.date,
      Object.values(this.dtwData.d_dryB).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.d_dewP).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.d_Temp_act).filter(function(x){ return x !== null}),      
      Object.values(this.dtwData.d_Temp).filter(function(x){ return x !== null}), 
      Object.values(this.dtwData.d_HVAC_act).filter(function(x){ return x !== null}),    
      Object.values(this.dtwData.d_HVAC).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.d_CCHW_act).filter(function(x){ return x !== null}),     
      Object.values(this.dtwData.d_CCHW).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.d_enthalpy).filter(function(x){ return x !== null}),
      Object.values(this.dtwData.d_typeBehavior).filter(function(x){ return x !== null}),
      )
    },
  },
  async mounted() {
    echarts.registerTheme('shine', shine)
    this.mainGraph = echarts.init(document.querySelector('#mainGraph'))
    await this.showGraph()
    
  }
}
</script>
